import { makeRule } from '@core/utils/rule'

export let searchRules = {}

export let formRules = {
  task_type: [
    {required: true, message: '任务类型不能为空', trigger: 'blur'},
  ],
  task_salary: [
    {required: true, message: '城市单价不能为空', trigger: 'blur'},
    {...makeRule('请输入小于1000的数字', 'number', ['change', 'blur']), min: 0, max: 1000},
  ],
}



// WEBPACK FOOTER //
// ./src/views/city-map/city-map.rules.js